/**
 * Central customer rating configuration.
 * Update this single source of truth and all UI components stay in sync.
 */
export const CUSTOMER_RATING = {
  /** Numeric rating score, e.g. 4.9 */
  score: 4.9,
  /** Maximum possible score, used for star rendering */
  maxScore: 5,
  /** Formatted customer count string */
  customerCount: "+10.000",
  /** Short label for the customer count */
  label: "+10.000 nöjda kunder",
  /** Full combined text: "4.9 (+10.000 nöjda kunder)" */
  fullText: "4.9 (+10.000 nöjda kunder)",
  /** Score rendered as a string with the configured precision */
  scoreText: "4.9",
} as const;
